import deleteAttachmentRequest from 'owa-service/lib/factory/deleteAttachmentRequest';
import DeleteAttachmentResponse from 'owa-service/lib/contract/DeleteAttachmentResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import deleteAttachmentOperation from 'owa-service/lib/operation/deleteAttachmentOperation';
import { ClientAttachmentId } from 'owa-client-ids';

function createRequestBody(attachmentId: ClientAttachmentId) {
    return deleteAttachmentRequest({
        ClientSupportsIrm: true,
        AttachmentIds: [attachmentId],
    });
}

export default function deleteAttachment(
    attachmentId: ClientAttachmentId
): Promise<DeleteAttachmentResponse> {
    const requestBody = createRequestBody(attachmentId);

    return deleteAttachmentOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body;
    });
}
